export class HeatingCheckModel {
  averageRoomTemperature: number;
  outdoorTemperatureAvailable: boolean;
  summerWinterOperationAvailable: boolean;
  emergencyStopAvailable: boolean;
  insulatedPipes: boolean;
  insulatingCaps: boolean;

  constructor() {
  }

  public static initialize(model: HeatingCheckModel): void {
  }
}
